import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FilterByIdPipe } from './filter-by-id.pipe';
import { FilterBrandsPipe } from './filter-brands.pipe';
import { BrandSearchPipe } from './brand-search.pipe';
import { ProfilePicturePipe } from './profilePicture.pipe';
import { UserSearchPipe } from './user-search.pipe';
import {SafePipe} from "./safe-pipe";
import {ArraySortPipe} from "../../Pipes/sort.pipe";
import {FilterByAdvType, FilterByIdName} from "../../Pipes/filter-by-name.pipe";


@NgModule({
    imports: [ 
        CommonModule 
    ],
    declarations: [
        FilterByIdPipe,
        FilterBrandsPipe,
        BrandSearchPipe,
        ProfilePicturePipe,
        UserSearchPipe,
        SafePipe,
        ArraySortPipe,
        FilterByIdName,
        FilterByAdvType
    ],
    exports: [
        FilterByIdPipe,
        FilterBrandsPipe,
        BrandSearchPipe,
        ProfilePicturePipe,
        UserSearchPipe,
        SafePipe,
        ArraySortPipe,
        FilterByIdName,
        FilterByAdvType
    ]
})
export class PipesModule { }
